import { iso6393languages } from '@src/assets/iso6393';

const audioLanguageCodes = new Set(iso6393languages.map(({ i }) => i));

export function isAudioLanguageCode(value: string): boolean {
  return audioLanguageCodes.has(value);
}

export function validAudioLanguageCodes(values: string[]): string[] {
  return values.filter(isAudioLanguageCode);
}
